import { ComplianceService } from "@/common/api.service";
import { FETCH_COMPLIANCE_DATA, FETCH_COMPLIANCE_REPORTS_DATA, RESET_STATE } from "./actions.type";
import { SET_COMPLIANCE_DATA, SET_COMPLIANCE_ERROR, SET_COMPLIANCE_REPORTS_DATA, SET_COMPLIANCE_REPORTS_ERROR, STATE_RESET } from "./mutations.type";


const initialState = () => {
  return {
    compliancedata: [],
    complianceerror: [],
    compliancereportsdata: [],
    compliancereportserror: []
  }
};

export const state = initialState();

const actions = {

  async [FETCH_COMPLIANCE_DATA](context, slug) {
    return await ComplianceService.get(slug).then(({data}) => {
      context.commit(SET_COMPLIANCE_DATA, data)
      return data
    }).catch((response) =>{
      context.commit(SET_COMPLIANCE_ERROR, (typeof response == Object? response.data.errorMessage : response))
      return response
    })
  },

  async [FETCH_COMPLIANCE_REPORTS_DATA](context, slug) {
    return await ComplianceService.get(slug).then(({data}) => {
      context.commit(SET_COMPLIANCE_REPORTS_DATA, data)
      return data
    }).catch((response) =>{
      context.commit(SET_COMPLIANCE_REPORTS_ERROR, (typeof response == Object? response.data.errorMessage : response))
      return response
    })
  },

  [RESET_STATE]({ commit }) {
    commit(STATE_RESET)
  }

}

const mutations = {

  [SET_COMPLIANCE_DATA](state, compliancedata) {
    state.compliancedata = compliancedata
  },
  [SET_COMPLIANCE_ERROR](state, error) {
    state.complianceerror = error
  },  
  [SET_COMPLIANCE_REPORTS_DATA](state, compliancereportsdata) {
    state.compliancereportsdata = compliancereportsdata
  },
  [SET_COMPLIANCE_REPORTS_ERROR](state, error) {
    state.compliancereportserror = error
  },  
  [STATE_RESET](state) {
    Object.assign(state,initialState())
  }

}

const getters = {
  compliancedata(state) {
    return state.compliancedata;
  },
  compliancereportsdata(state) {
    return state.compliancereportsdata;
  }
}

export default {
    state,
    getters,
    actions,
    mutations
};